import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DividerText from './DividerText';
import ClientProvider from './client';
export default createDemo(import.meta.url, DividerText, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/dividers/demos/text/DividerText.tsx",
    "fileName": "DividerText.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Divider from '@mui/material/Divider';\nimport Chip from '@mui/material/Chip';\n\nconst Root = styled('div')(({ theme }) => ({\n  width: '100%',\n  ...theme.typography.body2,\n  color: (theme.vars || theme).palette.text.secondary,\n  '& > :not(style) ~ :not(style)': {\n    marginTop: theme.spacing(2),\n  },\n}));\n\nexport default function DividerText() {\n  const content = (\n    <p>{`Lorem ipsum dolor sit amet, consectetur adipiscing elit.`}</p>\n  );\n\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Root>\n      {content}\n      <Divider>CENTER</Divider>\n      {content}\n      <Divider textAlign=\"left\">LEFT</Divider>\n      {content}\n      <Divider textAlign=\"right\">RIGHT</Divider>\n      {content}\n      <Divider>\n        <Chip label=\"Chip\" size=\"small\" />\n      </Divider>\n      {content}\n    </Root>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 34,
        "focusedLines": 13,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Divider from '@mui/material/Divider';\nimport Chip from '@mui/material/Chip';\n\nconst Root = styled('div')(({ theme }) => ({\n  width: '100%',\n  ...theme.typography.body2,\n  color: (theme.vars || theme).palette.text.secondary,\n  '& > :not(style) ~ :not(style)': {\n    marginTop: theme.spacing(2),\n  },\n}));\n\nexport default function DividerText() {\n  const content = (\n    <p>{`Lorem ipsum dolor sit amet, consectetur adipiscing elit.`}</p>\n  );\n\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Root>\n      {content}\n      <Divider>CENTER</Divider>\n      {content}\n      <Divider textAlign=\"left\">LEFT</Divider>\n      {content}\n      <Divider textAlign=\"right\">RIGHT</Divider>\n      {content}\n      <Divider>\n        <Chip label=\"Chip\" size=\"small\" />\n      </Divider>\n      {content}\n    </Root>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Root"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "content"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              ">CENTER</",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "content"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "textAlign"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "left",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">LEFT</",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "content"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "textAlign"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "right",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">RIGHT</",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "content"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Chip"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Chip",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "content"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Root"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 34,
    "focusedLines": 13,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Divider",
      "@mui/material/Chip"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
